export default { sha: 'a8cde7606f33707f914e247f7ccd48d9813a6cf4', buildNumber: 'undefined' }
